const STATUS_LABELS = {
  validated: "Validée",
  invalid: "À corriger",
  pending: "À vérifier",
  service_unavailable: "Service indisponible",
};

export function addressValidationLabel(validation) {
  return STATUS_LABELS[validation?.status] || STATUS_LABELS.pending;
}

export function addressImportNotice(summary) {
  if (!summary?.counts) return "";
  const count = ["invalid", "pending", "service_unavailable"].reduce((sum, key) => sum + (summary.counts[key] || 0), 0);
  return count > 0 ? `${count} commande${count > 1 ? "s" : ""} conservée${count > 1 ? "s" : ""} avec une alerte d’adresse.` : "";
}

export function buildAddressRoutingMetric(results = {}) {
  const technicalPrecheckCount = Number.isFinite(results.technical_precheck_failed_count)
    ? results.technical_precheck_failed_count : 0;
  const totalOrders = Number.isFinite(results.total_orders) ? results.total_orders : 0;
  return {
    key: "assignment-progress", label: technicalPrecheckCount > 0 ? "Adresses & routage" : "Adresses", value: String(technicalPrecheckCount),
    hoverCardTitle: "Adresses & routage", hoverCardMaxWidth: 420,
    isInteractive: technicalPrecheckCount > 0, tone: technicalPrecheckCount > 0 ? "danger" : "neutral",
    emphasis: technicalPrecheckCount > 0 ? "blocking" : "", errorTrigger: technicalPrecheckCount > 0,
    errorViewName: "errors", errorFilter: technicalPrecheckCount > 0 ? "technical_precheck" : "",
    errorSource: technicalPrecheckCount > 0 ? "results_overview" : "", ariaControls: "errors-center",
    ariaExpanded: "false", ariaLabel: "Ouvrir les alertes Adresses et routage",
    hoverCardDetails: {
      type: "formula",
      lines: [
        { label: "Commandes bloquées", value: String(technicalPrecheckCount) },
        { label: "Commandes visibles", value: String(totalOrders) },
      ],
      total: String(technicalPrecheckCount), totalLabel: "À corriger",
      note: technicalPrecheckCount > 0
        ? "Compte les commandes dont l'adresse ou le trajet ne peuvent pas être validés automatiquement. Tant qu'elles restent ici, elles doivent être corrigées avant de pouvoir être affectées."
        : "Compte les commandes dont l'adresse ou le trajet ne peuvent pas être validés automatiquement. Aucune commande visible n'est bloquée côté adresse ou trajet.",
    },
  };
}
